import clsx from "clsx";
import React from "react";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { TextInput } from "../criteria/TextInput";

interface ViewNameInputProps {
	error?: string;
	onChange: (e) => void;
}

export function ViewNameInput({ error, onChange }: ViewNameInputProps) {
	const { isMobile } = useAccessWindowSize();

	return (
		<div className={clsx("form-group", { error })}>
			<TextInput
				id="view-name"
				name="view"
				placeholder="Enter view name"
				label="View name"
				error={error}
				autoFocus={!isMobile}
				onChange={onChange}
			/>
		</div>
	);
}
